module.exports = __webpack_public_path__ + "static/media/mic.7b62528d.png";